import { Icon, IconPropsStrict, Stack, StackProps } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

export const InfoLine: FC<{
    icon: IconPropsStrict['name'];
    className?: string;
    alignItems?: StackProps['alignItems'];
    children?: ReactNode;
}> = ({ alignItems, children, className, icon }) => (
    <Stack
        className={classNames('c-neutral-200', className)}
        alignItems={alignItems ?? 'center'}
        spacing={1}
    >
        <Icon name={icon} className="c-neutral-90" />
        {children}
    </Stack>
);
